var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("label", { staticClass: "filter container" }, [
    _vm._v("\n\t" + _vm._s(_vm.i18n.labels[_vm.label]) + "\n\t"),
    _c("input", {
      attrs: { type: "checkbox", name: "free-filter-check" },
      domProps: { checked: _vm.isActive },
      on: { change: _vm.changeFilter }
    }),
    _vm._v(" "),
    _c("i", { ref: "checkmark", staticClass: "checkmark material-icons" }, [
      _vm._v(_vm._s(_vm.getCheckMark()))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }